// @flow
import isEmpty from '@justpark/helpers/src/isEmpty/isEmpty';

export default function withoutAppBanner(config: any) {
  const newConfig = { ...config };
  const appBannerName = 'apple-itunes-app';

  newConfig.app.head.meta = config.app.head.meta
    .map((val) => {
      if (val.name && val.name === appBannerName) {
        return null;
      }

      return val;
    })
    .filter((val) => !isEmpty(val));

  return newConfig;
}
